import React, { useEffect, useState } from 'react';
import { SelectMenu, Button, toaster } from 'evergreen-ui';
import PropTypes from 'prop-types';
import { api } from '../../../services/api';

const TypeFilter = ({ type, setType, disabled }) => {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([
    { label: 'All', value: 'all' },
  ]);

  async function fetchData() {
    setLoading(true);
    try {
      const { data } = await api.settings.get('features');
      setOptions([
        ...options,
        ...data.filter((o) => o.enabled).map((o) => ({ label: o.label.split('/')[1], value: o.name })),
      ]);
      setLoading(false);
    } catch (error) {
      toaster.danger('Error occured while loading "Type filter" data');
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (opt) => {
    if (setType) {
      setType(opt.value);
    }
  };

  // Only show active if the filter exists and it is not "All"
  const showActive = () => type && type !== options[0].value;

  return (
    <SelectMenu
      hasTitle={false}
      options={options}
      selected={type}
      onSelect={(v) => handleChange(v)}>

      <Button
        size="small"
        disabled={disabled || loading}
        appearance={showActive() ? 'primary' : 'default'}>
        Type:
        {' '}
        {!loading && type && options.length > 1 ? options.find((opt) => opt.value === type).label : 'All'}
      </Button>
    </SelectMenu>
  );
};

TypeFilter.propTypes = {
  type: PropTypes.string,
  setType: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

TypeFilter.defaultProps = {
  disabled: false,
};

export default TypeFilter;
